var ko = require('knockout');

var ManglerKurs = function(params) {
  var self = this;
  self.title = params.title;
  self.description = params.description;
  self.forwardLink = params.forwardLink;
  self.forwardLinkText = params.forwardLinkText;
};

module.exports = ManglerKurs;
